export const instructionData = {
  datasheets: [
    {
      unit: 1,
      title: 'Interval Frequency Duration',
      instructions: [
        'For Frequency document one tally mark for each time the behavior occurs during the time period it occurred.',
        'For Duration document the number of minutes the behavior occurred in the time interval that it occurred.',
      ],
      note: 'If no behavior occurred, record a zero. If absent, leave blank.',
    },
    {
      unit: 3,
      title: 'Partial Interval',
      instructions: [
        'Each Interval is a 10-minute period. Each number represents 1 minute of time. Put a plus symbol (+) in the box if the behavior occurs any time during the interval. Put a minus symbol (-) in the box if the behavior does not occur during the interval. Add the total plus (+) for each interval and put into the total column. The total number will be placed in the data collection of your student case in Insights to Behavior.',
      ],
    },
    {
      unit: 2,
      title: 'Latency',
      instructions: [
        'Document the duration(mins) from when the direction was given to the student to the end time as when the student begins the task or follow directions.',
      ],
      note: 'If no behavior occurred, record a zero. If absent, leave blank.',
    },
    {
      unit: 4,
      title: 'Replacement Behavior',
      instructions: [
        'Document each time the Replacement Behavior is used correctly:',
        'Request attention using a voice output device, Create routines to promote desired behaviors',
      ],
      details:
        'Request attention using a voice output device, Create routines to promote desired behaviors',
      note: 'If no behavior occurred, record a zero. If absent, leave blank.',
    },
  ],
};
